import React, { useState, useEffect } from 'react';
import styles from '../../../Filter.module.scss';

import { useFilters } from 'store/filters';
import {
  sergi,
  braslety,
  koltsa,
  podveski,
} from '../../../../model/subcategoryStore';

import { FilterDropdown } from 'shared/ui/FilterDropdown';
import { FilterCheckbox } from 'shared/ui/FilterCheckbox';

function SubcategoryFilter() {
  const [subcategoryArray, setSubcategoryArray] = useState([]);
  const { setFilters, category, subcategory } = useFilters((state) => ({
    setFilters: state.setFilters,
    category: state.filters.category,
    subcategory: state.filters.subcategory || [], // Теперь массив, а не строка
  }));

  const handleChange = (value) => {
    if (subcategory.includes(value)) {
      setFilters(
        'subcategory',
        subcategory.filter((v) => v !== value),
      );
    } else {
      setFilters('subcategory', [...subcategory, value]);
    }
  };

  useEffect(() => {
    const categorySubcategoryMap = {
      Подвески: podveski,
      Браслеты: braslety,
      Кольца: koltsa,
      Серьги: sergi,
    };

    setSubcategoryArray(categorySubcategoryMap[category] || []);
  }, [category]);

  const isCategoryWithSubcategory = [
    'Подвески',
    'Браслеты',
    'Кольца',
    'Серьги',
  ].includes(category);

  if (!isCategoryWithSubcategory) return null;

  return (
    <FilterDropdown title="Подкатегория" isOpen={subcategory.length > 0}>
      <div className={styles.contentContainer}>
        {subcategoryArray.map((item, index) => (
          <FilterCheckbox
            key={index}
            item={item}
            label={item.value}
            handleChange={() => handleChange(item.value)}
            checked={subcategory.includes(item.value)}
          />
        ))}
      </div>
    </FilterDropdown>
  );
}

export { SubcategoryFilter };
